// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__e2U2B","header":"ReportDetails_header__2laJo","title":"ReportDetails_title__kbNPn","left":"ReportDetails_left__21VhO"};